/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Gdpr_Anonymise_What_2Inputs */

const cs_gdpr_anonymise_what_2 = /** @type {(inputs: Gdpr_Anonymise_What_2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`e-maily, telefony, poznámky a texty aktivit se smažou`)
};

const en_gdpr_anonymise_what_2 = /** @type {(inputs: Gdpr_Anonymise_What_2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`e-mails, phones, notes and activity texts are deleted`)
};

/**
* | output |
* | --- |
* | "e-mails, phones, notes and activity texts are deleted" |
*
* @param {Gdpr_Anonymise_What_2Inputs} inputs
* @param {{ locale?: "cs" | "en" }} options
* @returns {LocalizedString}
*/
export const gdpr_anonymise_what_2 = /** @type {((inputs?: Gdpr_Anonymise_What_2Inputs, options?: { locale?: "cs" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Gdpr_Anonymise_What_2Inputs, { locale?: "cs" | "en" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_gdpr_anonymise_what_2(inputs)
	return cs_gdpr_anonymise_what_2(inputs)
});